import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
const POPULAR_TAGS = ['EMDR Therapy', 'Trauma Therapy', 'Couples Therapy', 'Individual Therapy', 'Family Therapy', 'Virtual Therapy', 'Anxiety & Stress', 'Grief & Loss', 'Relationship Issues', 'Parenting Support', 'PTSD', 'Life Transitions'];
export function SearchService() {
  const [searchQuery, setSearchQuery] = useState('');
  return <section id="search" className="py-12 lg:py-16 bg-olive" data-id="element-480">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-481">
        <div className="text-center mb-8" data-id="element-482">
          <span className="text-gold font-bold uppercase tracking-widest text-xs mb-3 block" data-id="element-483">
            FIND SUPPORT
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-484">
            What do you need help with?
          </h2>
          <p className="text-white/70 text-base font-medium" data-id="element-485">
            Search for a service or browse below
          </p>
        </div>

        <div data-id="element-486">
          <div className="relative max-w-xl mx-auto mb-8" data-id="element-487">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-488">
              <Search className="h-5 w-5 text-white/40" data-id="element-489" />
            </div>
            <input type="text" className="block w-full pl-11 pr-4 py-3.5 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/40 focus:ring-2 focus:ring-gold focus:border-transparent outline-none transition-all font-medium text-base" placeholder="e.g. anxiety, trauma, couples..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-490" />
          </div>

          <div className="flex flex-wrap justify-center gap-2" data-id="element-491">
            {POPULAR_TAGS.map(tag => <Link to="/services" key={tag} className="px-4 py-2 rounded-full text-sm font-medium transition-all bg-white/10 text-white/90 hover:bg-gold hover:text-white border border-white/15 hover:border-gold" data-id="element-492">
                {tag}
              </Link>)}
          </div>
        </div>
      </div>
    </section>;
}